import { ConsultType, getConsultationType } from '@/components/PatientPageV2/utils/getConsultationType';
import { useMemo } from 'react';

export const useChargeInitialDoctorConsult = (
  consultType: string | undefined,
  doctorId: number | undefined,
  hasPaidInitialNurseConsult: boolean | null | undefined,
) => {
  const result = useMemo(() => {
    let shouldNotChargeInitialDoctorConsultation = false;
    if (!consultType || !doctorId || !hasPaidInitialNurseConsult) {
      return { shouldNotChargeInitialDoctorConsultation };
    }

    const consultAndClinicianType = getConsultationType({
      consult_type: consultType,
      doctor_id: doctorId,
    });

    shouldNotChargeInitialDoctorConsultation = !!(
      consultAndClinicianType === ConsultType.InitialDoctor && hasPaidInitialNurseConsult
    );

    return { shouldNotChargeInitialDoctorConsultation };
  }, [consultType, doctorId, hasPaidInitialNurseConsult]);

  return result;
};
